import React from 'react'
// import delete_icon from '../../../assets/images/delete.svg'
import { close_icon } from '../../assets/images';


const PopUpModals = ({ visible = true, icon , title , description, onCancel, onPass, onClose = () => {}, onSave = () => {} }) => {
  
   return ( 
    <div
      className={`fixed z-20 inset-0 overflow-y-auto ${visible ? '' : 'hidden'}`}
      aria-labelledby='modal-title'  
      aria-modal='true'
      style={{width: '100%'}}
    >
      <div className='flex items-end justify-center text-center sm:block sm:p-0'>
        <div
          className='fixed inset-0 bg-opacity-80 transition-opacity'
          aria-hidden='true'
          style={{background: 'grey', opacity: '0.9', transition: 'opacity' }}
        >
        </div>
        <span className='sm:inline-block sm:align-middle sm:h-screen' aria-hidden='true'>
          &#8203;
        </span>  
        <div className="inline-block  align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-75 sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className='flex flex-row-reverse '>
              <img src={close_icon} alt='closeIcon' className='cursor-pointer' onClick={onClose} />
            </div>   
            <div className=" sm:flex sm:items-start">
              <div className="text-center sm:mt-0 sm:mx-4 sm:text-left flex flex-row">
                <div className='m-1 mr-4'>
                    <img src={icon} style={{width: '57px', height: '47px'}}/>
                </div>
                <div className='mr-16'>
                    <h3 className='text-xl leading-6 mt-1 font-bold text-gray-700'>
                        {title}
                    </h3>    
                    <p className='mt-2 text-base font-normal' style={{color: '#4D6189'}}>
                        {description}
                    </p> 
                </div> 
              </div>
            </div>
          </div>
          <div className="bg-gray-100 border-2 mt-3 h-20 px-4 p-3 pb-4 sm:px-6 sm:flex sm:flex-row-reverse">
            <button onClick = {onSave} className='text-white text-base bg-blue-600 hover:bg-blue-500 transition font-semibold rounded px-9 mx-2 py-3.5'>{onPass}</button>
            <button onClick ={onClose} className='text-blue-600 hover:bg-blue-100 transition rounded-md text-base font-semibold mx-4 px-9 py-3.5'>{onCancel}</button>
          </div>
        </div>
      </div>
    </div>   
  )
}

export default PopUpModals;
